module.exports = __webpack_public_path__ + "img/book-5562200_1280.47c76753.jpg";